const transformSuffix = '  '

const directionOptions = {
  movements: [
    { label: 'left', value: 'left' },
    { label: 'top', value: 'top' },
    { label: 'bottom', value: 'bottom' },
    { label: 'right', value: 'right' },
  ],
  rotations: [
    { label: 'clockwise', value: 'clockwise' },
    { label: 'anticlockwise', value: 'anticlockwise' },
  ],
}

const svgConstants = { transformSuffix, directionOptions }
export default svgConstants
